











































































































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { useFamilyStore } from "@/employee/store/family";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { formatMMddyyyyDateString } from "@/shared/dateString";
import { FamilyMember, FamilyMemberRelationship, FamilyMemberStatus } from "@/shared/types";
import * as _ from "lodash";
import EditDependent from "@/employee/components/settings/EditDependent.vue";
import { useThemeStore } from "@/shared/store/theme";

const emptyDependentModel: FamilyMember = {
  id: 0,
  firstName: "",
  lastName: "",
  tag: "",
  dateOfBirth: "",
  debitCardHolder: false,
  relationship: FamilyMemberRelationship.Dependent,
  ssn: "",
  status: FamilyMemberStatus.Active
};

@Component({
  components: {
    EditDependent
  }
})
export default class DependentTableView extends Vue {
  custodianSettingsStore = useCustodianSettingsStore();
  themeStore = useThemeStore();

  formatDateString = formatMMddyyyyDateString;
  familyStore = useFamilyStore();
  featureFlagStore = useFeatureFlagStore();
  editDependentParameters = {
    show: { value: false },
    dependent: { ...emptyDependentModel },
    onSave: this.onSaveDependent,
    toggleClose: this.closeEditDependentForm,
    isNew: false
  };
  showDeactivateConfirmationModal = false;
  showActivateConfirmationModal = false;
  isDeactivating = false;
  isActivating = false;

  @Prop ()
  dependents: FamilyMember[];

  @Prop ({ required: false, default: true })
  isActive: boolean;

  get profileAddEditEnabled () {
    return this.featureFlagStore.flags.bend17261EnableProfileAddEdit;
  }

  collapseId (id: number) {
    return `collapse-${id}`;
  }

  toggleDetails (id: any) {
    this.$root.$emit("bv::toggle::collapse", id);
    this.toggleCollapsedClass(id);
  }

  toggleCollapsedClass (id: any) {
    const elem = document.getElementById(id);
    if (elem.classList.contains("collapsed")) {
      elem.classList.remove("collapsed");
    } else {
      elem.classList.add("collapsed");
    }
  }

  middleInitial (dependent: FamilyMember) {
    if (dependent.middleInitial) {
      return dependent.middleInitial;
    }
    return "";
  }

  fullName (dependent: FamilyMember): string {
    return `${dependent.firstName} ${this.middleInitial(dependent)} ${dependent.lastName}`;
  }

  dateOfBirth (dependent: FamilyMember): string {
    return this.formatDateString(dependent.dateOfBirth);
  }

  relationship (dependent: FamilyMember): string {
    switch (dependent.relationship) {
      case FamilyMemberRelationship.Dependent:
        return "Dependent";
      case FamilyMemberRelationship.Spouse:
        return "Spouse";
      default:
        return "";
    }
  }

  status (dependent: FamilyMember): string {
    switch (dependent.status) {
      case FamilyMemberStatus.Active:
        return "Active";
      case FamilyMemberStatus.Inactive:
        return "Inactive";
      default:
        return "";
    }
  }

  lastFourSsn (dependent: FamilyMember): string {
    const ssnLength = dependent.ssn ? dependent.ssn.length : undefined;
    if (ssnLength) {
      return `***-**-${dependent.ssn.substring(7, ssnLength)}`;
    }

    return "";
  }

  showEditDependentForm (dependent: FamilyMember) {
    this.editDependentParameters.dependent = _.cloneDeep(dependent);
    this.editDependentParameters.show.value = true;
  }

  onDeactivateDependent (dependent: FamilyMember) {
    this.editDependentParameters.dependent = _.cloneDeep(dependent);
    this.showDeactivateConfirmationModal = true;
  }

  closeDeactivateConfirmationModal () {
    this.showDeactivateConfirmationModal = false;
  }

  confirmDeactivate () {
    this.isDeactivating = true;
    this.editDependentParameters.dependent.status = FamilyMemberStatus.Inactive;
    return this.familyStore.updateFamilyMember({
      id: this.editDependentParameters.dependent.id,
      familyMember: this.editDependentParameters.dependent
    })
    .then(() => {
      this.showDeactivateConfirmationModal = false;
    })
    .catch(() => {/*noop*/})
    .finally(() => {
        this.isDeactivating = false;
      });
  }

  onActivateDependent (dependent: FamilyMember) {
    this.editDependentParameters.dependent = _.cloneDeep(dependent);
    this.showActivateConfirmationModal = true;
  }

  closeActivateConfirmationModal () {
    this.showActivateConfirmationModal = false;
  }

  confirmActivate () {
    this.isActivating = true;
    this.editDependentParameters.dependent.status = FamilyMemberStatus.Active;
    return this.familyStore.updateFamilyMember({
      id: this.editDependentParameters.dependent.id,
      familyMember: this.editDependentParameters.dependent
    })
    .then(() => {
      this.showActivateConfirmationModal = false;
    })
    .catch(() => {/*noop*/})
    .finally(() => {
        this.isActivating = false;
      });
  }

  onSaveDependent () {
    return this.familyStore.updateFamilyMember({
      id: this.editDependentParameters.dependent.id,
      familyMember: this.editDependentParameters.dependent
    })
    .then(() => {
      this.editDependentParameters.show.value = false;
    })
    .catch(() => {/*noop*/});
  }

  closeEditDependentForm () {
    this.editDependentParameters.show.value = false;
  }
}
